import React, { useState, useEffect } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { Icon } from '../../assets/icons';
import SidebarSubmenu from './SidebarSubmenu';
import { Button } from '@windmill/react-ui';
import routes from '../../routes/Sidebar';
import Logo from '../../assets/logo.png';
import { getSites } from '../../redux/api/siteAPI';
import Select from '../ui/select';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';


const fallbackSites = [
  { Site_ID: 1, Name: 'yard 1' },
  { Site_ID: 2, Name: 'Room 2' },
  { Site_ID: 3, Name: 'Hallway 1' },
];

function SidebarContent() {
  const { t } = useTranslation('common');
  const [sitesList, setSitesList] = useState(null);
  const [site, setSite] = useState(null);
  const location = useLocation();
  const [pendingNotification, setPendingNotification] = useState(false);


  const not = useSelector((s) => s.notification?.pending || false);
  const sitesRefreshToken = useSelector((s) => s.sites?.refreshToken);
  useEffect(() => setPendingNotification(not), [not]);

  useEffect(() => {
    const fetch = async () => {
      try {
        const { error, data } = await getSites();
        setSitesList(data?.sites || fallbackSites);
        if (error) throw error;
      } catch {
        setSitesList(fallbackSites);
      }
    };
    fetch();
  }, [sitesRefreshToken]);

  return (
    <div className="py-3 px-5 text-gray-500 dark:text-gray-400 step1">
      {/* LOGO */}
      <div className="mt-8 flex items-center justify-center gap-2">
        <img className="h-9 w-auto" src={Logo} alt="Solyntek" />
        <NavLink to="/" className="mt-1 text-2xl font-medium text-side_bar_logo_txt_color">
          Solyntek
        </NavLink>
      </div>

      {/* NAVIGATION */}
      <ul className="mt-20 space-y-2">
        {routes.map((route) =>
          route.routes ? (
            <SidebarSubmenu route={route} key={route.name} />
          ) : (
            <li className={`relative ${route.path === '/alerts' ? 'step4' : ''}`} key={route.name}>
              <NavLink
                to={route.path}
                className={({ isActive }) =>
                  `px-4 py-3 inline-flex items-center w-full text-sm font-semibold transition-colors duration-150 rounded-lg ${
                    isActive
                      ? 'bg-white text-side_bar_selected_txt'
                      : 'text-side_bar_txt hover:text-gray-400'
                  }`
                }
              >
                <Icon className="w-5 h-5 shrink-0" icon={route.icon} />
                <span className="ml-4">{t(`sidebar.${route.name.toLowerCase()}`)}</span>
                {route.name === 'Alerts' && pendingNotification && (
                  <div
                    className="absolute right-4 top-1/2 -translate-y-1/2 flex items-center justify-center w-3 h-3 bg-[#0071BC] rounded-full shadow-2xl"
                    role="status"
                    aria-label={t('you_have_new_alert')}
                    title={t('you_have_new_alert')}
                  >
                    <span className="animate-ping absolute inset-0 rounded-full bg-[#0071BC] opacity-75"></span>
                    <span className="relative text-white text-[7px] font-bold leading-none">!</span>
                  </div>
                )}
              </NavLink>
            </li>
          )
        )}

        {/* MOBILE SITE SELECTOR */}
        <li className="md:hidden">
          {sitesList && location.pathname === '/' && (
            <Select
              onChange={(opt) => setSite(opt.value)}
              placeholder={t('select_site')}
              options={sitesList.map((s) => ({
                label: s.Name,
                value: s.Site_ID,
              }))}
            />
          )}
        </li>
      </ul>

      {/* SPACER */}
      <div className="mt-10 px-6">
      </div>
    </div>
  );
}

export default SidebarContent;